import React from 'react';
import { Link } from 'react-router-dom';

import MaxWidth from '../max-width';
import Menu from './menu';
import Logo from './logo';

import store, { toggleMenu } from '../../state';

import './header.css';

function toggleBurgerMenu(e, show = null) {
  if (e) e.preventDefault();
  store.dispatch(toggleMenu(show));
}

const Header = () => (
  <header>
    <MaxWidth className="header-wrap">
      <Link to="/" className="logo" onClick={() => toggleBurgerMenu(null, false)}>
        <Logo />
        <span className="title">DCG<span className="grey">Design</span></span>
      </Link>
      <a href="/" className="burger" onClick={toggleBurgerMenu}>
        <div>
          <div />
          <div />
          <div />
        </div>
      </a>
    </MaxWidth>
    <Menu />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js